import { useState } from "react";
import Header from "./components/Header";
import DonationCalls from "./components/DonationCalls";
import LocalInitiatives from "./components/LocalInitiatives";
import VolunteerCalls from "./components/VolunteerCalls";
import CollectionPoints from "./components/CollectionPoints";
import TrustedSites from "./components/TrustedSites";
import Evacuation from "./components/Evacuation";
import Map from "./components/Map";
import Medias from "./components/Medias";
import "./App.css";

function App() {
  const [activeTab, setActiveTab] = useState("initiatives");

  const renderContent = () => {
    switch (activeTab) {
      case "initiatives":
        return <LocalInitiatives />;
      case "donations":
        return <DonationCalls />;
      case "evacuation":
        return <Evacuation />;
      case "volunteers":
        return <VolunteerCalls />;
      case "collection-points":
        return <CollectionPoints />;
      case "trusted-sites":
        return <TrustedSites />;
      case "carte-chido-mayotte":
        return <Map />;
      case "medias":
        return <Medias />;
      default:
        return <DonationCalls />;
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="tab-navigation">
        <button
          className={`tab-link ${activeTab === "initiatives" ? "active" : ""}`}
          onClick={() => setActiveTab("initiatives")}
        >
          Cagnottes locales
        </button>
        <button
          className={`tab-link ${activeTab === "donations" ? "active" : ""}`}
          onClick={() => setActiveTab("donations")}
        >
          Appels aux dons nationaux
        </button>
        <button
          className={`tab-link ${activeTab === "evacuation" ? "active" : ""}`}
          onClick={() => setActiveTab("evacuation")}
        >
          Evacuations
        </button>
        <button
          className={`tab-link ${activeTab === "volunteers" ? "active" : ""}`}
          onClick={() => setActiveTab("volunteers")}
        >
          Appels à volontaires
        </button>
        <button
          className={`tab-link ${
            activeTab === "collection-points" ? "active" : ""
          }`}
          onClick={() => setActiveTab("collection-points")}
        >
          Points de collecte
        </button>
        <button
          className={`tab-link ${
            activeTab === "trusted-sites" ? "active" : ""
          }`}
          onClick={() => setActiveTab("trusted-sites")}
        >
          Sites de confiance
        </button>
        <button
          className={`tab-link ${
            activeTab === "carte-chido-mayotte" ? "active" : ""
          }`}
          onClick={() => setActiveTab("carte-chido-mayotte")}
        >
          Cartes
        </button>
        <button
          className={`tab-link ${activeTab === "medias" ? "active" : ""}`}
          onClick={() => setActiveTab("medias")}
        >
          Médias
        </button>
      </div>
      <div className="content-area">{renderContent()}</div>
    </div>
  );
}

export default App;
